import { render, staticRenderFns } from "./ContactsRegister.vue?vue&type=template&id=9968c6be&scoped=true&"
import script from "./ContactsRegister.vue?vue&type=script&lang=js&"
export * from "./ContactsRegister.vue?vue&type=script&lang=js&"
import style0 from "./ContactsRegister.vue?vue&type=style&index=0&id=9968c6be&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9968c6be",
  null
  
)

export default component.exports